"use client"

import React from 'react';
import { DatePicker as CDatePicker, ConfigProvider } from 'antd';
import locale from 'antd/locale/vi_VN';
import { mapModifiers } from '@/utils/funtion';
import Typography from '../typography';
import { Status } from '../rangepicker';
import { localeVN } from '@/statics/static';

interface IDatePickerProps {
    label?: string;
    name?: string;
    isRequired?: boolean
    autoFocus?: boolean
    placeholder?: string;
    status?: Status;
    format?: string;
    value?: Date;
    errorMessage?: string;
    onChange?: (date: Date) => void;
    disabled?: boolean
}

const DatePicker: React.FC<IDatePickerProps> = ({
    label, isRequired, autoFocus, placeholder, status, errorMessage, value, format, onChange, name, disabled
}) => {
    return (
        <div className={mapModifiers('a-datepicker', status)} >
            <div className="a-datepicker_label">
                <Typography type='p' content={label} modifiers={['14x21', 'capitalize']} />
                {isRequired && <span style={{ color: '#f00', marginLeft: 4 }}>*</span>}
            </div>
            <ConfigProvider locale={locale}>
                <CDatePicker
                    name={name}
                    locale={localeVN as any}
                    autoFocus={autoFocus}
                    placeholder={placeholder}
                    status={status}
                    format={format ?? 'DD-MM-YYYY'}
                    value={value ?? undefined}
                    onChange={(date: Date, dateString: string | string[]) => {
                        if (onChange) onChange(date)
                    }}
                    disabled={disabled}
                />
            </ConfigProvider>
            {
                errorMessage && (
                    <div className="a-datepicker-error_message">{errorMessage}</div>
                )
            }
        </div >
    );
}

export default DatePicker;
